"use client";

import { trackFaireDirectFaireDirectLandingPageSignUpClick } from "@faire/web-api/events/faireDirect/click/faireDirectLandingPageSignUp";
import { getCurrentPath } from "@faire/web/common/Path";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import {
  SignUpElement,
  SignUpType,
  usePopSignUp,
} from "@faire/retailer/lib/popSignUp";

import { SIGN_UP_BUTTON_WIDTH_DESKTOP } from "./consts";

interface IProps {
  brandToken: string | undefined;
}

export const SignUpButton: React.FC<IProps> = ({ brandToken }) => {
  const isSSR = useIsSSR();
  const { popSignUp } = usePopSignUp();

  const handleSignUp = (
    e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();
    popSignUp(
      SignUpType.FAIRE_DIRECT,
      () => trackFaireDirectFaireDirectLandingPageSignUpClick("BRAND_INFO"),
      {
        element: SignUpElement.HEADER,
        sourceId: "fd_landing_page_brand_info_signup_cta",
      },
      {
        brand: brandToken,
      }
    );
  };

  return (
    <StyledButton
      onClick={handleSignUp}
      data-test-id="faire-direct-sign-up-button-main"
      // We set a link for graceful degredation in SSR.
      linkTo={
        isSSR
          ? getCurrentPath()
              .replace({
                signUp: "brand",
                brand: brandToken,
              })
              .toString()
          : undefined
      }
    >
      <StrictLocalMsg
        defaultMessage="Sign up for free"
        description={{
          text: "Call to action to begin the sign up flow (CTA button text)",
          img: "https://cdn.faire.com/fastly/b4af2f5790b4e0752944ac056de2906b679cd6fd241b5101f29e827cc2523f2f.png",
        }}
      />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  width: fit-content;
  min-width: ${SIGN_UP_BUTTON_WIDTH_DESKTOP}px;
`;
